module.exports = __webpack_public_path__ + "static/media/ManageAppointments@2x.d48f6d59.jpg";